import useAuth from '@app/auth/use-auth';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';
import { cn, roundNumberToNDecimalPlaces } from '@shared/lib/utils';

interface AvgCarbonIntensityProps {
  averageEmissionsPerKg: number;
}

const AvgCarbonIntensity = ({
  averageEmissionsPerKg,
}: AvgCarbonIntensityProps) => {
  const { user } = useAuth();

  if (user!.productCategory === 'product') {
    return (
      <div
        className="bg-gray-50 p-4 md:w-[300px]"
        data-testid="average-carbon-intensity"
      >
        <div className="pl-2">
          <div className="flex size-11 items-center justify-center rounded-full bg-gray-25 p-3">
            <Icons.cloud size={25} />
          </div>
          <Text variant="body" className="mt-2">
            Average carbon intensity
          </Text>
          <div className="flex items-baseline">
            <Text
              className={cn('text-4xl font-bold mt-2', {
                'text-3xl': averageEmissionsPerKg > 9999,
              })}
            >
              {roundNumberToNDecimalPlaces(averageEmissionsPerKg, 2, false)}
            </Text>
            <Unit variant="kgCO2e/kgfood" className="ml-1" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 p-4" data-testid="average-carbon-intensity">
      <div className="flex p-4">
        <div className="mr-8 flex size-11 items-center justify-center rounded-full bg-gray-00 p-3">
          <Icons.cloud size={25} />
        </div>
        <div>
          <Text variant="body" className="text-nowrap">
            Average carbon intensity
          </Text>
          <div className="flex items-baseline">
            <Text className="mt-2 text-4xl font-bold">
              {roundNumberToNDecimalPlaces(averageEmissionsPerKg, 2, false)}
            </Text>
            <Unit variant="kgCO2e/kgfood" className="ml-1" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvgCarbonIntensity;
